(function () {
  var VAR = { dark: '44599671521367', green: '44599840014423' };
  var NAME = { dark: 'Dark Grey', green: 'Light Green' };
  var BASE = 'https://cdn.shopify.com/s/files/1/0680/5064/9175/files/';
  var PHOTO = { dark: BASE + 'iron-swatch-dark.jpg?v=1793587172', green: BASE + 'iron-swatch-green.jpg?v=1793587172' };
  var QTY = [1, 2, 4];

  function photo(el, key) {
    el.style.setProperty('background-image', 'url(' + PHOTO[key] + ')', 'important');
    el.style.setProperty('background-size', '175%', 'important');
    el.style.setProperty('background-position', 'center 58%', 'important');
    el.style.setProperty('background-repeat', 'no-repeat', 'important');
  }

  /* only the chosen bundle shows its colour rows */
  var st = document.createElement('style');
  st.textContent = '.mti-root .mti-hero-bundle:not(.is-selected) .mti-hero-bundle-options{display:none !important;}'
    + '.mti-root .mti-hero-bundle-select{position:relative !important;display:flex !important;justify-content:space-between !important;align-items:center !important;}'
    + '.mti-root .mti-hero-bundle-select select{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;font-size:16px;}'
    + '.mti-root .mti-hero-bundle{cursor:pointer;}'
    + '.mti-root .mti-faq-row{flex-wrap:wrap !important;row-gap:10px !important;cursor:pointer;}'
    + '.mti-root .mti-faq-row[data-house-open] .mti-faq-chevron{transform:rotate(180deg);}';
  document.head.appendChild(st);

  var bundles = [].slice.call(document.querySelectorAll('.mti-hero-bundle'));
  var colors = QTY.map(function (n) { var a = []; for (var k = 0; k < n; k++) a.push('dark'); return a; });
  var cur = 1;

  var KEYS = ['dark', 'green'];
  var sws = [].slice.call(document.querySelectorAll('.mti-hero-swatch'));
  var colorLabel = document.querySelector('.mti-hero-color-label');

  /* the line + circles under the title follow whatever colours are chosen in the pack */
  function syncHeader() {
    var c = colors[cur];
    var same = c.every(function (x) { return x === c[0]; });
    sws.forEach(function (s, i) { s.classList.toggle('is-selected', same && KEYS[i] === c[0]); });
    if (colorLabel) colorLabel.textContent = 'Steamer Color - ' + (same ? NAME[c[0]] : NAME.dark + ' + ' + NAME.green);
  }

  function setBuyLinks() {
    syncHeader();
    var cnt = {};
    colors[cur].forEach(function (c) { cnt[c] = (cnt[c] || 0) + 1; });
    var parts = Object.keys(cnt).map(function (c) { return VAR[c] + ':' + cnt[c]; });
    [].slice.call(document.querySelectorAll('a[data-js-buy]')).forEach(function (a) {
      a.setAttribute('href', '/cart/' + parts.join(','));
      a.removeAttribute('target');
    });
  }

  function buildOptions() {
    bundles.forEach(function (b, i) {
      var old = b.querySelector('.mti-hero-bundle-options');
      if (old) old.parentNode.removeChild(old);
      var box = document.createElement('div');
      box.className = 'mti-hero-bundle-options';
      var label = document.createElement('span');
      label.className = 'mti-hero-bundle-options-label';
      label.textContent = 'Steamer Color';
      box.appendChild(label);
      colors[i].forEach(function (c, r) {
        var row = document.createElement('div');
        row.className = 'mti-hero-bundle-option-row';
        row.style.setProperty('gap', '10px');
        var sw = document.createElement('span');
        sw.className = 'mti-hero-bundle-swatch';
        photo(sw, c);
        var wrap = document.createElement('div');
        wrap.className = 'mti-hero-bundle-select';
        var txt = document.createElement('span');
        txt.textContent = NAME[c];
        var arrow = document.createElement('span');
        arrow.textContent = '▾';
        var sel = document.createElement('select');
        sel.setAttribute('aria-label', 'Steamer color ' + (r + 1));
        Object.keys(NAME).forEach(function (k) {
          var o = document.createElement('option');
          o.value = k; o.textContent = NAME[k]; if (k === c) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          colors[i][r] = sel.value;
          txt.textContent = NAME[sel.value];
          photo(sw, sel.value);
          setBuyLinks();
        });
        wrap.appendChild(txt); wrap.appendChild(arrow); wrap.appendChild(sel);
        row.appendChild(sw); row.appendChild(wrap);
        box.appendChild(row);
      });
      b.appendChild(box);
    });
  }

  function pick(i) {
    cur = i;
    bundles.forEach(function (b, k) { b.classList.toggle('is-selected', k === i); });
    setBuyLinks();
  }
  bundles.forEach(function (b, i) {
    b.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.mti-hero-bundle-options')) return;
      pick(i);
    });
  });
  buildOptions();
  if (bundles.length) pick(1);

  /* ---- colour swatches under the title: set every piece to that colour ---- */
  (function () {
    var main = document.querySelector('.mti-hero-main-image');
    sws.forEach(function (s, i) {
      if (!KEYS[i]) return;
      photo(s, KEYS[i]);
      s.style.cursor = 'pointer';
      s.addEventListener('click', function () {
        colors = QTY.map(function (n) { var a = []; for (var k = 0; k < n; k++) a.push(KEYS[i]); return a; });
        buildOptions();
        setBuyLinks();
        if (main) main.style.setProperty('background-image', 'url(' + PHOTO[KEYS[i]] + ')', 'important');
      });
    });
    syncHeader();
  })();

  /* ---- gallery: thumbnails switch the main photo ---- */
  (function () {
    var main = document.querySelector('.mti-hero-main-image');
    var thumbs = [].slice.call(document.querySelectorAll('.mti-hero-thumb'));
    if (!main || !thumbs.length) return;
    var curT = 0;
    var first = getComputedStyle(main).backgroundImage;
    function img(i) { return getComputedStyle(thumbs[i]).backgroundImage; }
    function show(i) {
      curT = (i + thumbs.length) % thumbs.length;
      main.style.setProperty('background-image', img(curT), 'important');
    }
    thumbs.forEach(function (t, i) { t.style.cursor = 'pointer'; t.addEventListener('click', function () { show(i); }); });
    var ar = document.querySelectorAll('.mti-hero-thumb-arrow');
    if (ar[0]) ar[0].addEventListener('click', function () { show(curT - 1); });
    if (ar[1]) ar[1].addEventListener('click', function () { show(curT + 1); });
    main.style.setProperty('background-image', first, 'important');
  })();

  /* ---- the first two info rows ship without any text: fill them from the store policies ---- */
  (function () {
    var TXT = [
      { label: 'Free shipping on every order', html: 'Orders are processed within 1-3 business days. Delivery to the US typically takes 7-15 business days (9-18 business days internationally), and a tracking number is emailed once your order ships. Shipping is free on every order.' },
      { label: null, html: 'Not happy for any reason? Email <a href="mailto:support@easydailys.com">support@easydailys.com</a> within 30 days of delivery and we will refund you. See our <a href="/policies/refund-policy">Refund Policy</a> for details.' }
    ];
    var rows = [].slice.call(document.querySelectorAll('.mti-hero-acc-row'));
    TXT.forEach(function (t, i) {
      var row = rows[i];
      if (!row || row.querySelector('.mti-hero-acc-body')) return;
      var head = row.querySelector('.mti-hero-acc-head');
      if (t.label && head && head.firstElementChild) head.firstElementChild.textContent = t.label;
      var body = document.createElement('div');
      body.className = 'mti-hero-acc-body';
      body.style.setProperty('display', 'none', 'important');
      var p = document.createElement('p');
      p.className = 'mti-hero-acc-p';
      p.innerHTML = t.html;
      body.appendChild(p);
      row.appendChild(body);
    });
  })();

  /* ---- hero accordion: rows open and close ---- */
  [].slice.call(document.querySelectorAll('.mti-hero-acc-row')).forEach(function (row) {
    var panel = row.querySelector('.mti-hero-acc-body');
    if (!panel) return;
    var head = row.querySelector('.mti-hero-acc-head');
    var chev = row.querySelector('.mti-hero-acc-chevron');
    if (!head) return;
    head.style.cursor = 'pointer';
    head.addEventListener('click', function () {
      var hidden = panel.style.getPropertyValue('display') === 'none';
      if (hidden) panel.style.removeProperty('display'); else panel.style.setProperty('display', 'none', 'important');
      if (chev) chev.textContent = hidden ? '▾' : '▸';
    });
  });

  /* ---- FAQ ---- */
  [].slice.call(document.querySelectorAll('.mti-faq-row')).forEach(function (row) {
    row.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.wld-answer')) return;
      if (row.hasAttribute('data-house-open')) row.removeAttribute('data-house-open'); else row.setAttribute('data-house-open', '');
    });
  });

  /* ---- footer: use the store's homepage footer (isolated frame, no scripts / tracking) ---- */
  (function () {
    var anchor = document.querySelector('.mti-root');
    if (!anchor) return;
    fetch('/', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var all = [].slice.call(doc.querySelectorAll('.shopify-section-group-footer-group'));
      if (!all.length) return;
      var grp = doc.createElement('div');
      grp.className = 'tb-footer-wrap';
      [].slice.call(doc.querySelectorAll('script,noscript,iframe')).forEach(function (e) { e.parentNode.removeChild(e); });
      var base = doc.createElement('base');
      base.setAttribute('href', location.origin + '/');
      base.setAttribute('target', '_top');
      doc.head.insertBefore(base, doc.head.firstChild);
      var stl = doc.createElement('style');
      stl.textContent = 'html,body{margin:0 !important;padding:0 !important;overflow:hidden !important}';
      doc.head.appendChild(stl);
      doc.body.innerHTML = '';
      all.forEach(function (e) { grp.appendChild(e); });
      doc.body.appendChild(grp);
      var frame = document.createElement('iframe');
      frame.setAttribute('title', 'Footer');
      frame.setAttribute('scrolling', 'no');
      frame.style.cssText = 'display:block;width:100%;border:0;height:300px';
      frame.srcdoc = '<!doctype html>' + doc.documentElement.outerHTML;
      function fit() {
        try {
          var g = frame.contentDocument.querySelector('.tb-footer-wrap');
          if (g) frame.style.height = Math.ceil(g.getBoundingClientRect().height) + 'px';
        } catch (e) {}
      }
      frame.addEventListener('load', function () {
        fit();
        try { new ResizeObserver(fit).observe(frame.contentDocument.querySelector('.tb-footer-wrap')); } catch (e) {}
        setTimeout(fit, 400); setTimeout(fit, 1500);
      });
      window.addEventListener('resize', fit);
      anchor.parentNode.insertBefore(frame, anchor.nextSibling);
    }).catch(function () {});
  })();
})();
